import { useState, useEffect } from 'react';
import { Icon } from '@iconify/react';
import { useApi } from '../../hooks/useApi';

export default function StatsCards({ fecha, estatusActivo, onCardClick, endpoint }) {
  const [datos, setDatos] = useState({ pendiente: 0, enviado: 0, completado: 0, error:0 });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { get } = useApi(); 

  useEffect(() => {
    const fetchData = async () => {
      if (!fecha || !endpoint) return;

      setDatos({});
      setError(null);
      setLoading(true);

      const year = fecha.getFullYear();
      const month = String(fecha.getMonth() + 1).padStart(2, '0');
      const day = String(fecha.getDate()).padStart(2, '0');
      const isoFecha = `${year}-${month}-${day}`;

      try {
        const response = await get(endpoint, {
          params: { fecha: isoFecha }
        });

        console.log(response);
        const info = response[0] || { pendiente: 0, enviado: 0, completado: 0 };
        setDatos(info);
      } catch (err) {
        setError('Error al obtener datos');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [fecha, endpoint]); 

  const total = (datos.pendiente || 0) + (datos.enviado || 0) + (datos.completado || 0);

  const cardsData = [
    { icon: 'heroicons-outline:menu-alt-1', bgColor: 'bg-info-500', textColor: 'text-info-500', label: 'Total', value: total, estatus: '' },
    { icon: 'heroicons-outline:chart-pie', bgColor: 'bg-warning-500', textColor: 'text-warning-500', label: 'Completadas', value: datos.completado || 0, estatus: 'Completado' },
    { icon: 'heroicons-outline:clock', bgColor: 'bg-primary-500', textColor: 'text-primary-500', label: 'Pendientes', value: datos.pendiente || 0, estatus: 'Pendiente' },
    { icon: 'heroicons-outline:calculator', bgColor: 'bg-success-500', textColor: 'text-success-500', label: 'Enviadas', value: datos.enviado || 0, estatus: 'Enviado' },
    { icon: 'heroicons-outline:exclamation', bgColor: 'bg-danger-500', textColor: 'text-danger-500', label: 'Error', value: datos.error || 0, estatus: 'Error' },
  ];

  if (loading) return <p>Cargando datos...</p>;
  if (error) return <p className="text-red-500">Error: {error}</p>;

  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-3 h-full">
      {cardsData.map(({ icon, bgColor, textColor, label, value, estatus }, i) => {
        const isActive = estatusActivo === estatus;

        return (
          <div
            key={i}
            onClick={() => onCardClick && onCardClick(isActive ? '' : estatus)}
            className={`${bgColor} rounded-md px-3 py-2 flex items-center cursor-pointer transition
              ${isActive ? 'bg-opacity-40' : 'bg-opacity-15 hover:bg-opacity-30'}`}
          >
            <div className={`${textColor} h-8 w-8 flex items-center justify-center rounded-full bg-white text-xl mr-3`}>
              <Icon icon={icon} />
            </div>
            <div className="leading-tight">
              <span className="block text-xs text-slate-600 font-medium">{label}</span>
              <span className="block text-lg text-slate-900 font-semibold">{value}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
